export default __webpack_public_path__ + "static/media/boxing-gloves.d4347f11.png";